var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#121127"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C8.18227 21.5 4.89052 19.248 3.38065 16H6.25469C7.51964 17.8135 9.62125 19 12 19C15.866 19 19 15.866 19 12C19 11.8319 18.9941 11.6652 18.9824 11.5H14.875L16.25 15.125L14.5 17.125L11.75 9.25L18.4392 9.25H19.625H21.0959C21.3587 10.1205 21.5 11.0438 21.5 12ZM20.6194 8H17.7453C16.4804 6.18652 14.3787 5 12 5C8.13401 5 5 8.13401 5 12C5 12.1681 5.00593 12.3348 5.01758 12.5H9.125L7.75 8.875L9.5 6.875L12.25 14.75H5.56085H4.375H2.90411C2.64128 13.8795 2.5 12.9562 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C15.8177 2.5 19.1095 4.75197 20.6194 8Z",
    fill: "url(#paint0_linear_6771_37089)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6771_37089",
    x1: 2.5,
    y1: 21.5,
    x2: 21.5,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5208FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CFD3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlpm);
export default __webpack_public_path__ + "static/media/glpm.65bdcf45eff841d5b0d460c01d3c06fb.svg";
export { ForwardRef as ReactComponent };